import React from "react";
import styleClasses from "../../../../containers/account/accounts.module.scss";
import { PaymentCircleIconBlue } from "../../../../images/svgIcons/svg";

interface NoStoredPaymentsBannerProps {
  handleModalOpen: () => void;
  handleLookupOpen: () => void;
}

const NoStoredGiftCardBanner: React.FunctionComponent<
  NoStoredPaymentsBannerProps
> = ({ handleModalOpen, handleLookupOpen }) => {
  return (
    <>
      <div className={styleClasses.profile_inn_wrap + " text-center"}>
        <div className="mb-0 ">
          <h4 className="font-Cls text-start h-24 medium_text mb-4">
            Gift Cards
          </h4>
        </div>
        <div className={styleClasses.profile_content_wrap + " mx-auto"}>
          <div className={styleClasses.inn_content_wrap + " mx-auto"}>
            <PaymentCircleIconBlue/>
            <h1 className="h-24  font-Cls medium_text">
              You have no Gift
              <br /> Card...yet!
            </h1>
            <p className="f-sm-s14 mx-auto">
              Add a gift card to your account for a<br /> faster checkout
              experience!
            </p>
            <hr className="custom_hr_sty mt-5 mb-3  d-md-none" />
            <button
              type="button"
              className="btn btn-large"
              onClick={handleModalOpen}
              data-testid="add-new-payment-button"
            >
              ADD A Gift Card
            </button>
            <button
              type="button"
              className={`btn btn-large mt-3 ${styleClasses.lookupButton}`}
              onClick={handleLookupOpen}
              data-testid="gift-card-lookup"
            >
              GIFT CARD LOOKUP
            </button>
          </div>
        </div>
      </div>
      <hr className="custom_hr_sty  d-none d-md-block" />
    </>
  );
};

export default NoStoredGiftCardBanner;
